import { emptyPlaceholder } from '../../constants';

export const threeWay = ["Away", "Home", "Draw"];
export const threeWayMargin = [emptyPlaceholder, "Away", "Home", "Draw"];
export const winner = ["Away", emptyPlaceholder, "Home"];
export const yesNo = ["Yes", emptyPlaceholder, "No"];
export const overUnder = [emptyPlaceholder, "Over", "Under"];
export const doubleChance = ["Away/Draw", "Away/Home", "Draw/Home"];
export const awayHome = [emptyPlaceholder, "Away", "Home"];